import { useAppStore } from '@/features/shared/app-store';

import { hasAllGroups } from '@ecom/storefront-consent/consent-utils';
import { hasTCFPublisherConsent } from '@ecom/storefront-consent/has-tcf-publisher-consent';
import { useEffect, useState } from 'react';

/*C0001 => Mandatory Cookies
C0002 => Performance Cookies
C0003 => Functional Cookies
C0004 => Marketing Cookies
C0005 => Social Media Cookies*/
const REQUIRED_ONETRUST_IDS = ['C0002', 'C0004'];
const TCF_REQUIRED_PURPOSES = [1, 2, 3, 4, 7, 9, 10];

export const useHasWebGameConsent = (): boolean => {
  const activeGroups = useAppStore((s) => s.consent.activeGroups);
  const framework = useAppStore((s) => s.consent.framework);
  const [allowed, setAllowed] = useState<boolean | null>(null);

  useEffect(() => {
    let cancelled = false;

    const evaluateConsent = async () => {
      let nextAllowed = true;

      if (framework === 'TCF') {
        nextAllowed = await hasTCFPublisherConsent(TCF_REQUIRED_PURPOSES);
      } else if (framework === 'Quebec' || framework === 'LGPD') {
        nextAllowed = hasAllGroups(activeGroups, REQUIRED_ONETRUST_IDS);
      }

      if (!cancelled) {
        setAllowed(nextAllowed);
      }
    };

    void evaluateConsent();

    return () => {
      cancelled = true;
    };
  }, [framework, activeGroups]);

  return !!allowed;
};
